import { render, staticRenderFns } from "./FavoriteDialog.vue?vue&type=template&id=06ff541f&scoped=true&"
import script from "./FavoriteDialog.vue?vue&type=script&lang=js&"
export * from "./FavoriteDialog.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteDialog.vue?vue&type=style&index=0&id=06ff541f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff541f",
  null
  
)

export default component.exports